import { MaterialModule } from './shared/modules/material.module';
import { MenuComponent } from './shared/components/menu/menu.component';
import { MainComponent } from './Pages/main/main.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { ActualityModel } from './shared/models/actuality-model';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { MatMenuModule } from '@angular/material/menu';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EditorModule } from '@tinymce/tinymce-angular';
import { S3Service } from './shared/services/s3.service';

@NgModule({
  declarations: [AppComponent, HeaderComponent, MainComponent, MenuComponent],
  imports: [
    BrowserModule,
    EditorModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    RouterModule,
    MatMenuModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MaterialModule,
  ],
  providers: [ActualityModel, S3Service],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
